import { svgUrl } from '../../utils/staticUrls';
import { zIndex } from '../../config/styles';

export const classes = {
  container: 'woodcut-btn-container',
  button: 'woodcut-btn-button',
  iconContainer: 'woodcut-btn-icon-container',
  iconWrapper: 'woodcut-btn-icon-wrapper',
  pulseCircle: 'woodcut-btn-pulse-circle',
  icon: 'woodcut-btn-icon',
  closeIcon: 'woodcut-btn-close-icon',
  tooltipWrapper: 'woodcut-btn-tooltip-wrapper',
  woodCutterIcon: 'woodcut-btn-woodcutter-icon',
};

export const WoodCutOptimizerButtonStyles = (
  <style jsx>{`
    .woodcut-btn-container {
      display: flex;
      align-items: center;
      width: 100%;
      margin-bottom: 16px;
      position: relative;
    }
    .woodcut-btn-button {
      display: flex;
      align-items: center;
      justify-content: center;
      font-family: 'Lato', sans-serif;
      width: 100%;
      background: #fff;
      border: 1px solid #e8e8e8;
      border-radius: 4px;
      font-size: 16px;
      font-style: normal;
      color: #343e49;
      line-height: 20px;
      font-weight: 700;
      cursor: pointer;
      transition: all 0.2s ease;
      position: relative;
      height: 44px;
      box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
      margin-top: 0;
    }
    .woodcut-btn-button.mobile {
      margin-top: 20px;
    }
    .woodcut-btn-icon-container {
      position: absolute;
      left: -23px;
      top: 50%;
      transform: translateY(-50%);
    }
    .woodcut-btn-icon-container.mobile {
      top: -18px;
      left: 50%;
      transform: translateX(-50%);
    }
    .woodcut-btn-icon-wrapper {
      position: relative;
      width: 36px;
      height: 36px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 2px;
    }
    .woodcut-btn-pulse-circle {
      position: absolute;
      top: 50%;
      left: 50%;
      width: 14px;
      height: 14px;
    }
    .woodcut-btn-pulse-circle::before {
      content: '';
      position: absolute;
      top: -7px;
      left: -7px;
      width: 14px;
      height: 14px;
      border-radius: 50%;
      background: rgba(71, 163, 243, 0.3);
      animation: pulseRingBase1 2s ease infinite;
      transform-origin: 50% 50%;
    }
    .woodcut-btn-pulse-circle.layer2::before {
      background: rgba(71, 163, 243, 0.5);
      animation: pulseRingBase2 2s ease infinite;
    }
    .woodcut-btn-icon {
      position: absolute;
      top: 50%;
      left: 50%;
      width: 14px;
      height: 14px;
      transform: translate(-50%, -50%);
      z-index: ${zIndex.WoodCutOptimizerButton.button};
      background: rgba(71, 163, 243, 1);
      border-radius: 50%;
    }
    .woodcut-btn-close-icon {
      font-size: 20px;
      line-height: 1;
      color: #999;
      margin-left: 4px;
      display: flex;
      align-items: center;
      font-weight: 300;
    }
    .woodcut-btn-tooltip-wrapper {
      position: relative;
      width: 100%;
    }
    .woodcut-btn-woodcutter-icon {
      background-image: url(${svgUrl('wood-cutter.svg')});
      background-repeat: no-repeat;
      width: 25px;
      height: 24px;
      margin-right: 8px;
    }
    @keyframes pulseRingBase1 {
      0% {
        transform: scale(1);
        opacity: 0;
      }
      20% {
        transform: scale(1.5);
        opacity: 0.5;
      }
      35% {
        transform: scale(2);
        opacity: 0.7;
      }
      50% {
        transform: scale(2);
        opacity: 0.7;
      }
      65% {
        transform: scale(2);
        opacity: 0.5;
      }
      80% {
        transform: scale(2);
        opacity: 0.3;
      }
      100% {
        transform: scale(2);
        opacity: 0;
      }
    }
    @keyframes pulseRingBase2 {
      0% {
        transform: scale(2);
        opacity: 0;
      }
      45% {
        transform: scale(2);
        opacity: 0;
      }
      60% {
        transform: scale(2.5);
        opacity: 0.4;
      }
      75% {
        transform: scale(3);
        opacity: 0.5;
      }
      85% {
        transform: scale(3);
        opacity: 0.2;
      }
      100% {
        transform: scale(3);
        opacity: 0;
      }
    }
  `}</style>
);
